import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { BroadcastNotification } from "@/types/broadcast-notification";
import { toast } from "sonner";

export const useBroadcastNotifications = () => {
  const queryClient = useQueryClient();

  const { data: broadcasts = [], isLoading, error } = useQuery({
    queryKey: ['broadcast-notifications'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('broadcast_notifications')
        .select('*')
        .order('created_at', { ascending: false });
      
      if (error) throw error;
      return (data || []) as BroadcastNotification[];
    },
  });

  const sendBroadcast = useMutation({
    mutationFn: async (params: {
      title: string;
      message: string;
      link?: string;
      target_type: 'all' | 'role' | 'department' | 'specific_employees';
      target_value?: string;
      target_employees?: string[];
      priority?: 'urgent' | 'high' | 'normal' | 'low';
      expires_at?: string;
      channels?: string[];
    }) => {
      const currentEmployeeId = localStorage.getItem('currentEmployeeId');
      if (!currentEmployeeId) throw new Error('لم يتم تحديد الموظف الحالي');

      const { data, error } = await supabase.rpc('send_broadcast_notification', {
        p_title: params.title,
        p_message: params.message,
        p_link: params.link || null,
        p_sent_by: currentEmployeeId,
        p_target_type: params.target_type,
        p_target_value: params.target_value || null,
        p_target_employees: params.target_employees || null,
        p_priority: params.priority || 'normal',
        p_expires_at: params.expires_at || null,
        p_channels: params.channels || ['in_app']
      });

      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['broadcast-notifications'] });
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
      toast.success('تم إرسال الإشعار الجماعي بنجاح');
    },
    onError: (error: any) => {
      toast.error(`فشل إرسال الإشعار: ${error.message}`);
    }
  });

  return {
    broadcasts,
    isLoading,
    error,
    sendBroadcast: sendBroadcast.mutate,
    isSending: sendBroadcast.isPending
  };
};